import { useConfigStore } from '../stores/ConfigStore';
import { getModule } from '../modules/container';
import AccountController from '../controllers/AccountController';
import { useAccountStore } from '../stores/AccountStore';

let lastRefreshTimestamp = Date.now();

export const reloadUserSession = async () => {
  // Prevent this check when the config is not loaded yet. This fixes a bug where the app loads without the correct
  // integration because the AccountController depends on the INTEGRATION_TYPE dependency.
  const isConfigLoaded = useConfigStore.getState().loaded;
  if (!isConfigLoaded) {
    return;
  }

  const accountController = getModule(AccountController);
  const isLoggedIn = !!useAccountStore.getState().user;

  if (Date.now() - lastRefreshTimestamp < 60_000) {
    return;
  }

  lastRefreshTimestamp = Date.now();

  // reload the user session and subscriptions
  if (isLoggedIn) {
    await accountController.loadUserData(true);
    await accountController.reloadSubscriptions();
  }
};
